// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ca9a337","239":"f0a1d199","455":"db030f7f"}[chunkId] + ".chunk.js";
};